import { FC } from 'react'

import DropdownMenuItem from 'src/components/ui/atoms/DropdownMenuItem'
import LogoutIcon from 'src/components/ui/atoms/Icons/LogoutIcon'
import useAccount from 'src/hooks/useAccount'

const LogoutMenu: FC = () => {
  const { logout } = useAccount()

  return (
    <DropdownMenuItem
      icon={<LogoutIcon className="text-hit-gray" />}
      label="Logout"
      data-testid="header-settings-menu-logout"
      onClick={() => logout()}
    />
  )
}

export default LogoutMenu
